(function () {
    'use strict';

    angular.module('elogbooks.admin.service-providers', []);
})();
